import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import Sidebar from "../Sidebar";
import { getUserModule, updateDoctorModules, updateModule } from "../../services/doctor/module/module";
import { useMessageApi } from "../../services/message api/MessageProvider";

// --- Sub-Component: ModuleCard ---
const ModuleCard = ({ name, isEnabled, onClick }) => {
  const accentColor = "#007aff";

  const cardStyle = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "110px",
    border: isEnabled ? `2px solid ${accentColor}` : "1px solid #eee",
    borderRadius: "12px",
    backgroundColor: isEnabled ? "#f0f7ff" : "#fcfcfc",
    cursor: "pointer",
    padding: "10px",
    transition: "all 0.2s ease",
  };

  const checkmarkStyle = {
    position: "absolute",
    top: "8px",
    right: "8px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: accentColor,
    color: "white",
    fontSize: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
  };

  return (
    <div style={cardStyle} onClick={onClick}>
      {isEnabled === 1 && <div style={checkmarkStyle}>✓</div>}
      <div
        style={{
          width: "45px",
          height: "45px",
          backgroundColor: isEnabled ? accentColor : "#ccc",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      />
      <div style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
        {name}
      </div>
    </div>
  );
};

ModuleCard.propTypes = {
  name: propTypes.string.isRequired,
  isEnabled: propTypes.number.isRequired,
  onClick: propTypes.func.isRequired,
};

// --- Main Component ---
const SelectModulesAndData = () => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const messageApi = useMessageApi();


  // 1. Fetch and Flatten Data
  const fetchModuleData = async () => {
    try {
      setLoading(true);
      const result = await getUserModule();
      if (result.success && result.data.length > 0) {
        // Accessing the nested module_permissions from the first object in response
        const permissions = result.data[0].module_permissions || [];
        setModules(permissions);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchModuleData();
    // Sidebar logic from your original code
    document.body.classList.add("mini-sidebar");
  }, []);

  // 2. Toggle is_enabled (1 or 0)
  const handleToggle = (id) => {
    setModules((prev) =>
      prev.map((mod) =>
        mod.id === id ? { ...mod, is_enabled: mod.is_enabled === 1 ? 0 : 1 } : mod
      )
    );
  };

  // 3. Submit logic with exact object structure
  const handleSubmit = async () => {
    const payload = {
      module_permissions: modules.map((mod) => ({
        id: mod.id,
        name: mod.name,
        is_enabled: mod.is_enabled,
      })),
    };
    try {
      const result = await updateModule(payload);
      if (result.success) {
        messageApi.success("Modules updated successfully.");
      } else {
        messageApi.error("Update failed: " + result.error);
      }
    } catch (err) {
      console.error("Submit error:", err);
      messageApi.error("An error occurred while updating modules.");
    }
    
  };
  useEffect(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-doctor");
        sidebar.id = "menu-item1"; // Change ID if needed
      }
      
        document.body.classList.remove("expand-menu");
        document.body.classList.add("mini-sidebar");
  
    }, []);

  return (
    <div>
      <Sidebar activeClassName="consultantion-fee" />
      <div className="page-wrapper-doctor">
        <div className="content">
          <div className="page-header">
            <h3 className="page-title font-weight-bold">Module Settings</h3>
          </div>

          <div className="card">
            <div className="card-body">
              <header
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <h1 style={{ fontSize: "20px" }}>Select Modules</h1>
                <button
                  onClick={handleSubmit}
                  style={{
                    backgroundColor: "#007aff",
                    color: "white",
                    border: "none",
                    padding: "8px 20px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Save Changes
                </button>
              </header>

              {loading ? (
                <p>Loading modules...</p>
              ) : (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
                    gap: "15px",
                  }}
                >
                  {modules.map((mod) => (
                    <ModuleCard
                      key={mod.id}
                      name={mod.name}
                      isEnabled={mod.is_enabled}
                      onClick={() => handleToggle(mod.id)}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectModulesAndData;